import * as React from "react";
import Header from "./organisms/header/header";
import Footer from "./organisms/footer/footer";
import "../styles/global.scss";

/**
 * @type {Object} 「UI:レイアウト コンポーネント」DOMです。
 * @return {Object} DOMを返します。
 * @param {Array} children 子コンポーネントを受け取るための引数です。任意の要素を渡します。
 *
 */

const Layout = ({ children }) => {
  return (
    <div>
      <Header />
      {children}
      <Footer />
    </div>
  );
};

export default Layout;
